import React, {ChangeEvent, useCallback, useState} from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import {Divider, TextField} from "@mui/material";
import style from './AuthModalBody.module.css'
import {API} from "../../../../../controllers";
import {LeftArrow} from "../../../../LeftArrow/LeftArrow";
import {useStoreSystem} from "../../../../../store";

interface AuthModalBodyProps {
    handleSaveProjectWithAuth: (isRewriteProject?: boolean) => void
    handleBackButton: () => void;
}

export const AuthModalBody = (props: AuthModalBodyProps) => {
    const {handleSaveProjectWithAuth, handleBackButton} = props
    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [authError, setAuthError] = useState<string>('')
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const currentProjectUserId = useStoreSystem.getState().currentProjectUserId

    const handleEmailChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }, [])

    const handlePasswordChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
    }, [])

    const handleAuthAndSaveProject = useCallback(async () => {
        setIsLoading(true)
        const res = await API.Bitrix.authorizationByLogin(email, password)
        if (res.auth) {
            setAuthError('')
            if (res.userId === currentProjectUserId) {
                handleSaveProjectWithAuth(true)
            } else {
                handleSaveProjectWithAuth(false)
            }
        } else {
            setAuthError(res.error?.replaceAll("<br>",""))
        }
        setIsLoading(false)
    }, [currentProjectUserId, email, handleSaveProjectWithAuth, password])

    return (<>
        <div className={style.backButton}>
            <LeftArrow onClick={handleBackButton}/>
        </div>
        <DialogTitle className={style.title}>
            {"Авторизация"}
        </DialogTitle>
        <DialogContent>
            <div className={style.inputsForm}>
                <TextField value={email} onChange={handleEmailChange} type={'email'} label={'Email'} fullWidth disabled={isLoading}/>
                <TextField value={password} onChange={handlePasswordChange} type={'password'} label={'Пароль'} fullWidth disabled={isLoading}/>
                <a href={'/recovery'} target={'_blank'} className={style.forgotLabel}>Забыли пароль?</a>
                {authError && <div className={style.authError}>{authError}</div>}
            </div>
            <Divider/>
            <div className={style.buttonsForm}>
                <Button disabled={isLoading} variant={'contained'} onClick={handleAuthAndSaveProject}>
                    Авторизоваться и сохранить проект
                </Button>
                <Divider/>
                <div>Еще не зарегистрированы?</div>

                <Button disabled={isLoading} variant={'contained'}>
                    <a className={style.registerLink} href={'/registration'} target={'_blank'}>
                        Зарегистрироваться
                    </a>
                </Button>
            </div>
        </DialogContent>
    </>)
}